import React, { useEffect, useState } from "react"
import MultiSelect from "../../../components/atoms/MultiSelect.atom"

const TaskTeamMemberDropdown = ({
  teamMembers,
  selectedTeamMembers,
  setSelectedTeamMembers,
}) => {
  const [label, setLabel] = useState("Integrantes: Todos")
  const id = `task-team-member-picker-${new Date().getTime()}`
  useEffect(() => {
    const teamMembersLength = teamMembers.flatMap((el) => el.items).length
    if (selectedTeamMembers.length === 0) {
      setLabel("Integrantes: Todos")
    } else if (selectedTeamMembers.length === 1) {
      const name = teamMembers
        .flatMap((el) => el.items)
        .find(
          (member) => member.followerId === selectedTeamMembers[0]
        ).fullNameTag
      setLabel(name)
    } else if (selectedTeamMembers.length < teamMembersLength) {
      setLabel(`${selectedTeamMembers.length} integrantes seleccionados`)
    } else if (selectedTeamMembers.length === teamMembersLength) {
      setLabel("Integrantes: Todos")
    }
  }, [selectedTeamMembers])

  const labelTemplate = () => {
    return (
      <span>
        <i className="pi pi-user mr-2"></i>
        {label}
      </span>
    )
  }

  return (
    <MultiSelect
      inputId={id}
      optionGroupTemplate={(option) => {
        return <div>{option.active ? "Activo" : "Inactivo"}</div>
      }}
      disabled={teamMembers.length === 0}
      filter
      optionGroupChildren="items"
      optionGroupLabel="active"
      className="team-member-picker"
      panelClassName="team-member-picker-following-tasks max-w-23rem"
      value={selectedTeamMembers}
      options={teamMembers}
      onChange={(e) => setSelectedTeamMembers(e.value)}
      scrollHeight="417px"
      optionLabel="fullNameTag"
      optionValue="followerId"
      placeholder={labelTemplate()}
      maxSelectedLabels={0}
      itemTemplate={(option) => {
        return (
          <span className="overflow-hidden white-space-nowrap text-overflow-ellipsis">
            {option.fullNameTag}
          </span>
        )
      }}
      selectedItemsLabel={labelTemplate()}
    />
  )
}

export default TaskTeamMemberDropdown
